type ChatSpectatorInput = {
  userEntryCount: number | undefined;
  isCommissioner: boolean;
};

export const isChatSpectator = ({ userEntryCount, isCommissioner }: ChatSpectatorInput): boolean =>
  !userEntryCount && !isCommissioner;
